import {
  SEMS_GET,
  SEM_ADD,
  SEM_EDIT,
  SEM_GET,
  SEM_DELETE,
} from './reduxConstant';
import { createReducer } from '../../../../app/common/utilities/reducerUtils';

const initialState = {
  total: 0,
  search: {
    currentPage: '',
    searchText: '',
    itemPerPage: '',
  },
  items: [],
};

const semsGet = (state, payload) => {
  const sems = payload.sems;
  return {
    ...state,
    total: sems.total,
    items: [...sems.items],
    search: { ...sems.search },
  };
};

const semAdd = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) + 1,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.sem.id + ''),
      payload.sem,
    ],
  };
};

const semEdit = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.sem.id + ''),
      payload.sem,
    ],
  };
};

const semGet = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.sem.id + ''),
      payload.sem,
    ],
  };
};

const semDelete = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) - 1,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.sem.id + ''),
    ],
  };
};

export default createReducer(initialState, {
  [SEMS_GET]: semsGet,
  [SEM_ADD]: semAdd,
  [SEM_EDIT]: semEdit,
  [SEM_GET]: semGet,
  [SEM_DELETE]: semDelete,
});
